import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Sayfa başlığı + opsiyonel açıklama + sağ tarafta primary/secondary aksiyon.
 * CMS sayfaları bu shell'i wrap eder; padding ve typography tek noktadan
 * gelir.
 */
export function PageHeader({
  title,
  description,
  actions,
  badge,
  className,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  badge?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        "flex flex-col gap-3 border-b border-border-subtle bg-bg-card px-4 py-4 md:px-8 md:py-6",
        "md:flex-row md:items-start md:justify-between md:gap-6",
        className,
      )}
    >
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex flex-wrap items-center gap-2.5">
          <h1 className="font-display text-xl md:text-2xl font-semibold text-text-primary tracking-tight">
            {title}
          </h1>
          {badge ? <div className="shrink-0">{badge}</div> : null}
        </div>
        {description ? (
          <p className="max-w-2xl text-sm text-text-secondary">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap shrink-0 items-center gap-2">{actions}</div>
      ) : null}
    </header>
  );
}

export function PageBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("px-4 py-4 md:px-8 md:py-6", className)}>{children}</div>;
}
